export enum SalesChannelEnum {
  WEBSITE = "WEBSITE",
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  MESSENGER = "MESSENGER",
  GOOGLEMYBUSINESS = "GOOGLEMYBUSINESS",
  WHATSAPP = "WHATSAPP",
}
